import { createContext, useContext } from 'react'

type ScrollContextType = {
  scrollContainerId?: string
  stickyTop: string
  scrollToTop: () => void
}

export const ScrollContext = createContext<ScrollContextType>({
  stickyTop: '64px',
  scrollToTop: () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
})

export const useScrollContext = () => useContext(ScrollContext)
